export default "__VITE_ASSET__DTWVmdkr__"